import { Eye } from 'lucide-react';

/**
 * Banner shown at the top of a RouteOps page when the user has view-only
 * access. Write UI (Create/Edit/Delete/Save) on the page should be hidden
 * or disabled.
 */
export default function ReadOnlyBanner({ pageName }) {
  return (
    <div
      className="mb-4 flex items-center gap-3 rounded-md border px-4 py-2.5"
      style={{
        background: 'var(--amber-glow, rgba(245,166,35,0.12))',
        borderColor: 'var(--amber, #f5a623)',
        color: 'var(--amber, #f5a623)',
      }}
      data-testid="read-only-banner"
    >
      <Eye className="h-4 w-4 flex-shrink-0" />
      <div className="text-xs font-semibold uppercase tracking-wider" style={{ fontFamily: 'var(--fd)' }}>
        Read-only access{pageName ? ` — ${pageName}` : ''}
      </div>
      <div className="text-xs opacity-80">
        You can view but not modify. Contact an Admin to request edit rights.
      </div>
    </div>
  );
}
